import { useState, createContext, useContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTheme } from "@/comn/hooks";
import classNames from "classnames";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { comnUtils } from "@/comn/utils";

const Context = createContext<any>(null);

const schema = {
    summary: [
        { name: "Arraival Report", bsopClsfCd: "CGM", bsopTpNm: ["VAR", "AAR"], type: 0 },
        { name: "Departure report", bsopClsfCd: "CGM", bsopTpNm: ["VDP", "ADP"], type: 0 },
        { name: "License", bsopClsfCd: "LCM", bsopTpNm: [""], type: 0 },
        { name: "LPCO", bsopClsfCd: "ESA", bsopTpNm: [""], type: 0 },
        { name: "Manifest", bsopClsfCd: "CGM", bsopTpNm: ["ISM", "IAM", "ITM", "IRM"], type: 0 },
        { name: "Transport", bsopClsfCd: "CGM", bsopTpNm: ["BTD", "CTD", "STD", "SPD"], type: 0 },
        { name: "Carry-in", bsopClsfCd: "CGM", bsopTpNm: ["CRI_BL", "CRI_VHCL", "CRI_CNTR", "CIP", "HPR"], type: 0 },
        {
            name: "Carry-out",
            bsopClsfCd: "CGM",
            bsopTpNm: ["CRO_BL", "CRO_VHCL", "CRO_CNTR", "COP", "OVER_CAG"],
            type: 0,
        },
        /* { name: "Etc", bsopClsfCd: "CGM", bsopTpNm: ["C2D", "SCN", "ENT"], type: 0 }, */
        { name: "TANSAD(EX)", bsopClsfCd: "CGM", bsopTpNm: ["IM4", "IM5", "IM6", "IM7", "IM8"], type: 0 },
        { name: "TANSAD(IM)", bsopClsfCd: "CGM", bsopTpNm: ["EX1", "EX2", "EX3"], type: 0 },
        { name: "TRA(Collection)", bsopClsfCd: "COL", bsopTpNm: [], type: 1 },
        { name: "OGA(Collection)", bsopClsfCd: "ESF", bsopTpNm: [], type: 1 },
    ],
    others: [
        { name: "Arraival Report", bsopClsfCd: "CGM", bsopTpNm: ["VAR", "AAR"], type: 0 },
        { name: "Departure report", bsopClsfCd: "CGM", bsopTpNm: ["VDP", "ADP"], type: 0 },
        { name: "License", bsopClsfCd: "LCM", bsopTpNm: [""], type: 0 },
        { name: "LPCO", bsopClsfCd: "ESA", bsopTpNm: [""], type: 0 },
        { name: "Manifest", bsopClsfCd: "CGM", bsopTpNm: ["ISM", "IAM", "ITM", "IRM"], type: 0 },
        { name: "Transport", bsopClsfCd: "CGM", bsopTpNm: ["BTD", "CTD", "STD", "SPD"], type: 0 },
        { name: "Carry-in", bsopClsfCd: "CGM", bsopTpNm: ["CRI_BL", "CRI_VHCL", "CRI_CNTR", "CIP", "HPR"], type: 0 },
        {
            name: "Carry-out",
            bsopClsfCd: "CGM",
            bsopTpNm: ["CRO_BL", "CRO_VHCL", "CRO_CNTR", "COP", "OVER_CAG"],
            type: 0,
        },
        /* { name: "Etc", bsopClsfCd: "CGM", bsopTpNm: ["C2D", "SCN", "ENT"], type: 0 }, */
        { name: "TANSAD(EX)", bsopClsfCd: "CGM", bsopTpNm: ["IM4", "IM5", "IM6", "IM7", "IM8"], type: 0 },
        { name: "TANSAD(IM)", bsopClsfCd: "CGM", bsopTpNm: ["EX1", "EX2", "EX3"], type: 0 },
        { name: "TRA(Bill amount)", bsopClsfCd: "COL", bsopTpNm: [], type: 1 },
        { name: "OGA(Bill amount)", bsopClsfCd: "ESF", bsopTpNm: [], type: 1 },
        { name: "TRA(Paid amount)", bsopClsfCd: "COL", bsopTpNm: [], type: 1 },
        { name: "OGA(Paid amount)", bsopClsfCd: "ESF", bsopTpNm: [], type: 1 },
    ],
};

const DashboardTemp = () => {
    const getDashboardData = async () => {
        const base = process.env.REACT_APP_API_PTLI;
        const path = "/api/v1/ptl/dshbrd/list";
        const response = await axios.get(base + path);

        console.log(response.data.data.content);

        const dataList = response.data.data.content;

        // summary
        console.log(getSummary(dataList.summary));
        // daily
        console.log(getOthers(dataList.daily));
        // monthly
        console.log(getOthers(dataList.monthly));
        // annual
        console.log(getOthers(dataList.annual));
    };

    const getSummary = (list: Array<any>) => {
        const result = [];

        for (let i = 0; i < schema.summary.length; i++) {
            const item = {
                name: schema.summary[i].name,
                doneCnt: 0,
                pndgCnt: 0,
                totCnt: 0,
                sumBllAmt: 0,
                sumRcptAmt: 0,
                today: 0,
                lastDay: 0,
                type: schema.summary[i].type,
            };
            for (let j = 0; j < list.length; j++) {
                if (
                    list[j].bsopClsfCd === schema.summary[i].bsopClsfCd &&
                    schema.summary[i].bsopTpNm.indexOf(list[j].bsopTpNm) > -1
                ) {
                    item.doneCnt += list[j].doneCnt;
                    item.pndgCnt += list[j].pndgCnt;
                    item.totCnt += list[j].totCnt;
                    item.sumBllAmt += list[j].sumBllAmt;
                    item.sumRcptAmt += list[j].sumRcptAmt;
                }
            }
            result.push(item);
        }

        return result;
    };

    const getOthers = (list: Array<any>) => {
        const result = [];

        for (let i = 0; i < schema.others.length; i++) {
            const item = {
                name: schema.others[i].name,
                doneCnt: 0,
                pndgCnt: 0,
                totCnt: 0,
                sumBllAmt: 0,
                sumRcptAmt: 0,
                today: 0,
                lastDay: 0,
                type: schema.others[i].type,
            };
            for (let j = 0; j < list.length; j++) {
                if (
                    list[j].bsopClsfCd === schema.others[i].bsopClsfCd &&
                    schema.others[i].bsopTpNm.indexOf(list[j].bsopTpNm) > -1
                ) {
                    // 고지금액
                    if (schema.others[i].name === "TRA(Bill amount)" || schema.others[i].name === "OGA(Bill amount)") {
                        item.today += list[j].currBllAmt;
                        item.lastDay += list[j].lastBllAmt;
                    } else if (
                        schema.others[i].name === "TRA(Paid amount)" ||
                        schema.others[i].name === "OGA(Paid amount)"
                    ) {
                        item.today += list[j].currRcptAmt;
                        item.lastDay += list[j].lastRcptAmt;
                    } else {
                        item.today += list[j].currTotCnt;
                        item.lastDay += list[j].lastTotCnt;
                    }
                }
            }
            result.push(item);
        }

        return result;
    };

    useEffect(() => {
        getDashboardData();
    }, []);

    return <></>;
};

export default DashboardTemp;
